// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__270c0","modalForm":"UpgradeEpcsModal_modalForm__3UAx4","modalFooter":"UpgradeEpcsModal_modalFooter__2DhVZ"};